import React from "react";
import Country from "../../containers/country";
import { Layout } from "antd";
import "./styles.css";
import Navbar from "../../components/navbar";
const { Header, Footer, Content } = Layout;

function index() {
  return (
    <div>
      <Layout>
        <Header>
          <Navbar />
        </Header>
        <Content>
          <Country />
        </Content>
        <Footer>Footer</Footer>
      </Layout>
    </div>
  );
}

export default index;
